import type { ActivityDetail } from '@painpal/contracts';
import { LoadMethodBadge } from '../../components/LoadMethodBadge';
import { formatWhole, noLoadLabel } from '../../lib/format';
import { CountUp } from '../../ui/CountUp';
import { loadFormula } from './detailModel';
import styles from './detail.module.css';

export function LoadCard({ activity }: { activity: ActivityDetail }) {
  const formula = loadFormula(activity);
  return (
    <section className={styles.loadCard} aria-labelledby="load-label">
      <div className={styles.loadTop}>
        <span id="load-label" className={styles.loadLabel}>LOAD</span>
        <LoadMethodBadge activity={activity} />
      </div>
      <span className={styles.loadValue}>{activity.load === null ? '—' : <CountUp value={activity.load} format={formatWhole} />}</span>
      <span className={styles.formula}>
        {formula === null ? noLoadLabel(activity) : (
          <>
            {formula.math}
            <span data-part="sep">{'   ·   '}</span>
            <span data-part="threshold">{formula.threshold}</span>
          </>
        )}
      </span>
    </section>
  );
}
